(function () {
    'use strict';

    angular
        .module('app.shared')
        .component('sc3NavigationBar', {
            templateUrl: 'app/shared/navigation-bar/navigation-bar.component.html',
            controller: NavigationBarComponent
        });

    var $ = angular.element,
        noop = angular.noop;

    NavigationBarComponent.$inject = ['$scope', '$window', '$state', 'user', 'signInManager', 'memberLookupModal', 'clubMembershipLevelType', 'upgradeModal', 'clubAdminStateName'];
    function NavigationBarComponent($scope, $window, $state, user, signInManager, memberLookupModal, clubMembershipLevelType, upgradeModal, clubAdminStateName) {
        // Variables
        var ctrl = this;

        // Properties
        ctrl.user = user;
        ctrl.hideTopNavigation = false;
        ctrl.isNavExpanded = false;
        Object.defineProperty(ctrl, 'isAdminPage', { get: getIsAdminPage });
        Object.defineProperty(ctrl, 'isClubAdminPage', { get: getIsClubAdminPage });
        Object.defineProperty(ctrl, 'canUpgrade', { get: getCanUpgrade });

        // Methods
        ctrl.$onInit = init;
        ctrl.signOut = signOut;
        ctrl.showMemberLookup = showMemberLookup;
        ctrl.closeExpandedNav = closeExpandedNav;
        ctrl.showUpgradeModal = upgradeModal;

        ///////////////////////////////////////////

        function init() {
            $($window).on("scroll", $scope.$apply.bind($scope, setVisibility));
            function setVisibility() {
                ctrl.hideTopNavigation = $window.pageYOffset > 60;
            }
        }

        function signOut() {
            signInManager.signOut();
        }

        function showMemberLookup() {
            memberLookupModal().result.then(navigate, noop);

            function navigate(member) {
                $state.go('scoring', { individualId: member.individualId });
            }
        }

        function closeExpandedNav() {
            ctrl.isNavExpanded = false;
        }
        
        function getIsAdminPage() {
            var data = $state.$current.data;
            return data && data.requireAdmin;
        }

        function getIsClubAdminPage()
        {
            var state = $state.$current;
            return ctrl.isAdminPage && state.includes[clubAdminStateName];
        }

        function getCanUpgrade() {
            return !ctrl.isAdminPage && user.membershipLevel === clubMembershipLevelType.Bronze;
        }
    }
})();